import React, { useState, useEffect } from 'react';
import { Row, Col, Card, CardBody } from 'reactstrap';
import classNames from 'classnames';
import DOMPurify from 'dompurify';
import { Link } from 'react-router-dom';
import useGetVersions from '../services/useGetVersions';
import PageLoader from '../components/PageLoader';
import { FaArrowRightLong } from "react-icons/fa6";
import Pagination from './Pagination';
import { MdOutlineKeyboardBackspace } from 'react-icons/md';


function ViewAllVersions(props) {
    const [pageNumber, setPageNumber] = useState(1);
    const [pageSize] = useState(10);
    const { getAllVersion, getAllVersionLoading } = useGetVersions(pageNumber, pageSize);

    const formatDate = (dateString) => {
        if (!dateString) return "";
        return dateString.split("T")[0];
    };
    const handlePageChange = (newPage) => {
        if (newPage >= 1 && newPage <= getAllVersion.totalPages) {
            setPageNumber(newPage);
        }
    };
    useEffect(() => {
        if (!getAllVersionLoading && getAllVersion?.items?.length === 0 && getAllVersion.totalCount > 0 && pageNumber > 1) {
            setPageNumber(pageNumber - 1);
        }
    }, [getAllVersionLoading, getAllVersion?.items?.length, getAllVersion?.totalCount, pageNumber]);

    return (
        <>
            <Row className='p-2'>
                <Col className="d-flex align-items-center" style={{ gap: '10px' }}>
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb mb-0 bg-transparent p-0">
                            <li className="breadcrumb-item">
                                <Link to="/info/versions" style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '5px',

                                }}>
                                    <MdOutlineKeyboardBackspace
                                        style={{
                                            cursor: 'pointer',
                                            fontSize: '20px',

                                        }}
                                    />
                                    <p style={{ marginBottom: '0px' }}>
                                        Specialty365 Versions</p>
                                </Link>
                            </li>
                            <li className="breadcrumb-item active" aria-current="page">
                                Previous Versions
                            </li>
                        </ol>
                    </nav>
                </Col>
            </Row>
            <Row className="justify-content-center mt-3">
                <Col md={10} lg={10} xl={8}>
                    {getAllVersionLoading && <PageLoader />}

                    {!getAllVersionLoading && getAllVersion?.items?.length === 0 && (
                        <div className="text-center text-muted mt-4">
                            No versions available.
                        </div>
                    )}

                    {!getAllVersionLoading && getAllVersion?.items?.length > 0 &&
                        [...getAllVersion?.items]
                            .map(note => (
                                <Link
                                    key={note.version}
                                    to={`/info/view-version-detail/${note.id}`}
                                    className="text-decoration-none text-reset"
                                >
                                    <Card key={note.version} className="border rounded shadow-sm mb-3 cursor-pointer ribbon-box"
                                        onMouseEnter={e => {
                                            e.currentTarget.classList.add(
                                                'bg-light',
                                                'border-primary',
                                                'shadow'
                                            );
                                        }}
                                        onMouseLeave={e => {
                                            e.currentTarget.classList.remove(
                                                'bg-light',
                                                'border-primary',
                                                'shadow'
                                            );
                                        }}>
                                        <CardBody>
                                            <div className="float-left">
                                                <div
                                                    className={classNames(
                                                        'ribbon-two',
                                                        'ribbon-two-primary'
                                                    )}
                                                >
                                                    <span>{note.version}</span>
                                                </div>
                                            </div>
                                            <div className="d-flex justify-content-end align-items-center mb-2 " style={{ gap: '12px' }}>
                                                <h5

                                                >
                                                    Version: {note.version} - {note.title}
                                                </h5>

                                            </div>

                                            <div className="ribbon-content">
                                                <p
                                                    className="mb-0"
                                                    dangerouslySetInnerHTML={{
                                                        __html: DOMPurify.sanitize(
                                                            note.description
                                                        )
                                                    }}
                                                />
                                            </div>

                                            {note.pharmUserDescription && (
                                                <>
                                                    <hr />
                                                    <div className="ribbon-content">
                                                        <p
                                                            className="mb-0"
                                                            dangerouslySetInnerHTML={{
                                                                __html: DOMPurify.sanitize(
                                                                    '<b>Admin Update:</b><br>' +
                                                                    note.pharmUserDescription
                                                                )
                                                            }}
                                                        />
                                                    </div>
                                                </>
                                            )}

                                            <hr />
                                            <div className="d-flex justify-content-between w-100">
                                                <div className="text-muted">
                                                    <b>{formatDate(note.date)}</b> - <b>By: {note.author}</b>
                                                </div>

                                            </div>

                                        </CardBody>
                                    </Card>
                                </Link>
                            ))}
                </Col>
            </Row>
            {/* pagination for versions */}
            <Pagination
                pageNumber={pageNumber}
                pageSize={pageSize}
                totalCount={getAllVersion.totalCount}
                totalPages={getAllVersion.totalPages}
                onPageChange={handlePageChange}
            />



        </>
    );
}

export default ViewAllVersions;